import React, { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import MovieCard from "./MovieCard";

export default function MovieRow({ title, videos, size = "md" }) {
  const ref = useRef(null);
  if (!videos || videos.length === 0) return null;
  const scroll = (dir) => {
    const amount = 600 * dir;
    ref.current?.scrollBy({ left: amount, behavior: "smooth" });
  };
  return (
    <section className="relative mb-10 group/row" data-testid={`row-${title.replace(/\s+/g, "-").toLowerCase()}`}>
      <div className="flex items-center justify-between mb-3 px-6 lg:px-12">
        <h2 className="text-xl md:text-2xl font-semibold text-white tracking-tight">{title}</h2>
        <span className="text-xs text-gray-500 uppercase tracking-widest">{videos.length} titles</span>
      </div>
      <div className="relative">
        <button
          onClick={() => scroll(-1)}
          className="absolute left-0 top-0 bottom-0 z-20 w-12 lg:w-20 bg-gradient-to-r from-[#0A0A0A] to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity flex items-center justify-center hover:text-white text-gray-400"
          aria-label="scroll left"
        >
          <ChevronLeft className="w-8 h-8" />
        </button>
        <div
          ref={ref}
          className="flex gap-3 overflow-x-auto scrollbar-hide snap-x snap-mandatory px-6 lg:px-12 pb-4"
        >
          {videos.map((v) => (
            <MovieCard key={v.id} video={v} size={size} />
          ))}
        </div>
        <button
          onClick={() => scroll(1)}
          className="absolute right-0 top-0 bottom-0 z-20 w-12 lg:w-20 bg-gradient-to-l from-[#0A0A0A] to-transparent opacity-0 group-hover/row:opacity-100 transition-opacity flex items-center justify-center hover:text-white text-gray-400"
          aria-label="scroll right"
        >
          <ChevronRight className="w-8 h-8" />
        </button>
      </div>
    </section>
  );
}
